import router from "./router";
import store from "./store";
import { getToken } from "@/utils/auth"; // getToken from cookie
router.beforeEach(async (to, from, next) => {
  if (getToken()) {
    const storePermissions = store.getters["getPermissions"];
    if (to.meta && to.meta.permissions) {
      let isAllowed = storePermissions.some((p) => to.meta.permissions === p);
      if (!isAllowed) return next("/");
    }
  }
  next();
});
